import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import React from 'react';
import clsx from 'clsx';
import TableBody from "../../TableBody";
import TableCell from "../../TableCell";
import TableRow from "../../TableRow";


import { createStyles } from "./styles";
import MarketingCell from "./MarketingCell";
import AttributeCell from "./AttributeCell";
import { isVariantAddedToCart } from "../utils";

var ComparisonTableBody = function ComparisonTableBody(_ref)









{var portfolios = _ref.portfolios,loading = _ref.loading,productLineAttributes = _ref.productLineAttributes,productLine = _ref.productLine,cartItems = _ref.cartItems,columnsAmount = _ref.columnsAmount,marketingTags = _ref.marketingTags,changeBgStyle = _ref.changeBgStyle,showWideColumns = _ref.showWideColumns;
  var classes = createStyles({ columnsAmount: columnsAmount, showWideColumns: showWideColumns });

  // Filter attributes by product line label, not product line id!
  var attributesInPl = _filterInstanceProperty(productLineAttributes).call(productLineAttributes,
  function (attr) {return attr.productLine === productLine && !attr.hidden;});


  // Save previous category name, if the name is new - show row with new category name
  var previousCategory = '';

  // List of cells with marketing tags
  var MarketingTagsCells = _mapInstanceProperty(portfolios).call(portfolios,
  function (_ref2) {var products = _ref2.products,portfolioId = _ref2.id,marketingTagIds = _ref2.marketingTagIds;
    // Determines the width of the cell with tags.
    // The tags are portfolio related, not products or variants, so their tags are combined in a cell
    var marketingColumnsAmount = 0;

    products.forEach(function (_ref3) {var bcDependentData = _ref3.bcDependentData;
      marketingColumnsAmount += _Object$values(bcDependentData).length;
    });

    return /*#__PURE__*/(
      React.createElement(MarketingCell, {
        key: "marketing_cell_".concat(portfolioId),
        marketingTagIds: marketingTagIds,
        portfolioId: portfolioId,
        marketingTags: marketingTags,
        columnsAmount: marketingColumnsAmount,
        showWideColumns: showWideColumns }));


  });


  // Multi product portfolio with some variants should be displayed in order - product 1 - variant 1 -> product 2-variant 1
  // Other portfolios render as usual
  var sortedProductsByVariants = function sortedProductsByVariants(
  variants,
  products,
  attrId,
  link,
  cartItem)
  {
    var cells = [];
    var variantsAmount = variants.length;
    variants.forEach(function (bcIndex) {
      products.forEach(function (_ref4, index) {var _context, _context2;var imProductId = _ref4.imProductId,bcDependentData = _ref4.bcDependentData,disabled = _ref4.disabled;
        var attrCell = /*#__PURE__*/
        React.createElement(AttributeCell, {
          key: _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = "attr_".concat(attrId, "_value_")).call(_context2, imProductId, "_")).call(_context, bcIndex),
          productAttributes: bcDependentData[bcIndex].productAttributes,
          attrId: attrId,
          link: link,
          isDisabled: disabled,
          isPortfolioAddedToCart:
          isVariantAddedToCart(cartItem, bcIndex) && changeBgStyle || false,

          showWideColumns: showWideColumns,
          cellStyle:
          products.length === index + 1 && variantsAmount === bcIndex + 1 ?
          classes.lastProductCell :
          '' });



        cells.push(attrCell);
      });
    });

    return cells;
  };

  // Row with category and rows with attributes
  var rowsList = _mapInstanceProperty(attributesInPl).call(attributesInPl, function (_ref5) {var displayName = _ref5.displayName,id = _ref5.id,category = _ref5.category,link = _ref5.link;
    var attributeCells = _mapInstanceProperty(portfolios).call(portfolios, function (_ref6) {var products = _ref6.products,portfolioId = _ref6.id;
      // Change the background of the cells depending on whether the portfolio is added to the cart
      var cartItem = _findInstanceProperty(cartItems).call(cartItems, function (item) {return item.portfolioId === portfolioId;});

      // Object keys makes string from any type. In BcDependentData interface keys are numbers
      var variants = _Object$keys(products[0].bcDependentData);

      return sortedProductsByVariants(variants, products, id, !!link, cartItem);
    });

    // Row formation
    var rowsWithCategory = /*#__PURE__*/
    React.createElement(React.Fragment, { key: "attr_".concat(id, "_row") },

    category && previousCategory !== category ? /*#__PURE__*/
    React.createElement(TableRow, { key: category, className: classes.categoryRow }, /*#__PURE__*/
    React.createElement(TableCell, { className: classes.categoryCell }, category)) : /*#__PURE__*/


    React.createElement(React.Fragment, null), /*#__PURE__*/


    React.createElement(TableRow, null, /*#__PURE__*/
    React.createElement(TableCell, { className: classes.attributeNameCell }, displayName),
    attributeCells));




    previousCategory = category;
    return rowsWithCategory;
  });

  return /*#__PURE__*/(
    React.createElement(TableBody, { loading: loading, maxHeight: "100%", className: classes.comparisonTableBody }, /*#__PURE__*/

    React.createElement(TableRow, null, /*#__PURE__*/
    React.createElement(TableCell, { className: clsx(classes.attributeNameCell, classes.marketingTagsCell) }, "Tags"),


    MarketingTagsCells),


    rowsList));


};

export default ComparisonTableBody;
//# sourceMappingURL=index.js.map